import React, { useContext } from 'react';

export enum PostLayoutSize {
  mobile = 'mobile',
  tablet = 'tablet',
  desktop = 'desktop',
  monitor = 'monitor',
}

const POST_LAYOUT_SIZES: Record<PostLayoutSize, [number, number]> = {
  [PostLayoutSize.mobile]: [0, 655],
  [PostLayoutSize.tablet]: [655, 916],
  [PostLayoutSize.desktop]: [916, 1670],
  [PostLayoutSize.monitor]: [1670, Number.MAX_SAFE_INTEGER],
};

export function getCurrentPostLayoutSize({
  baseWidth,
}: {
  baseWidth: number;
}): PostLayoutSize {
  const size = Object.entries(POST_LAYOUT_SIZES).find(
    ([, [min, max]]) => baseWidth >= min && baseWidth < max,
  )?.[0] as PostLayoutSize | null;

  return size ?? PostLayoutSize.mobile;
}

const PostLayoutSizeContext = React.createContext(PostLayoutSize.mobile);

export const usePostLayoutSize = () => useContext(PostLayoutSizeContext);
export const useIsPostLayoutSize = (size: PostLayoutSize) =>
  usePostLayoutSize() === size;

const PostLayoutSizeProvider = ({
  children,
  postLayoutSize,
}: {
  children: React.ReactNode;
  postLayoutSize: PostLayoutSize;
}) => {
  return (
    <PostLayoutSizeContext.Provider value={postLayoutSize}>
      {children}
    </PostLayoutSizeContext.Provider>
  );
};

export default PostLayoutSizeProvider;
